/**
 * Service for providing the last editor string
 */

import User from "../User"

class LastEditorEntry {
  static options = {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    second: "2-digit",
    year: "numeric",
  }

   static getLastEditorMessage() {
    const user = User.getFullName();
    const date = new Date().toLocaleDateString('DE-de', LastEditorEntry.options)

    return `${user} am ${date}`
  }
}

export default LastEditorEntry;
